var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { clickedConsentContinueButton, completedPage } from "../lib/Avo";
import AppBody from "../components/AppBody";
import ConnectButton from "../components/connect-ui/Button";
import Container from "../components/connect-ui/Container";
import Header from "../components/Header";
import Image from "../components/Image";
import { PHASE } from "../routeConfig";
import RouteHeaderLogo from "../components/RouteHeaderLogo";
import RouteTitle from "../components/RouteTitle";
import useAffiliateConfig from "../hooks/useAffiliateConfig";
import useAppSelector from "../hooks/useAppSelector";
import useCurrentProductLine from "../hooks/useCurrentProductLine";
import { useHistory } from "react-router-dom";
var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
};
var mobile = isMobile.iOS() || isMobile.Android();
var checkText = "check your insurance";
var partnerName = "Savvy";
export default function ConnectConsentRoute() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var history = useHistory();
    var trellisPrivacyPolicyURL = useAffiliateConfig().trellisPrivacyPolicyURL;
    var items = [
        {
            title: "Secure",
            icon: "/assets/icons/secure.svg",
            text: "Encryption helps protect your personal financial data",
        },
        {
            title: "Private",
            icon: "/assets/icons/private.svg",
            text: "Your credentials will never be made accessible to ".concat(partnerName),
        },
    ];
    // @todo find a better way to handle this logic
    var productLine = useCurrentProductLine();
    var isHome = productLine === "home";
    var credentialRoute = isHome
        ? PHASE.HOME_ENTER_CREDENTIALS
        : PHASE.ENTER_CREDENTIALS;
    function handleSubmit(ev) {
        clickedConsentContinueButton(commonAnalyticsProperties);
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
        history.push(credentialRoute);
    }
    function getDefaultHeaderText() {
        var partnerBlob = "".concat(partnerName, " uses ");
        var textSpaceMappings = [
            {
                maxLength: 8,
                // eslint-disable-next-line react/display-name
                Component: function () { return (React.createElement(React.Fragment, null,
                    partnerBlob,
                    React.createElement("span", { className: "font-bold" }, "Trellis"),
                    " to ",
                    React.createElement("br", null),
                    checkText)); },
            },
            {
                maxLength: Infinity,
                // eslint-disable-next-line react/display-name
                Component: function () { return (React.createElement(React.Fragment, null,
                    partnerBlob,
                    React.createElement("br", null),
                    " to ",
                    checkText)); },
            },
        ];
        var TextSpaceComponent = (textSpaceMappings.find(function (_a) {
            var maxLength = _a.maxLength;
            return partnerName.length <= maxLength;
        }) || textSpaceMappings[0]).Component;
        return React.createElement(TextSpaceComponent, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(Container, { className: "grow items-center overflow-y-scroll" },
                React.createElement("div", { className: "mb-4 flex items-end pt-0 text-black-100 md:pt-5" },
                    React.createElement("div", null, mobile ? (React.createElement(Image, { src: "/assets/images/connect-consent/mobile-device.svg", width: "24", height: "43", alt: "", className: "mr-[5px]" })) : (React.createElement(Image, { src: "/assets/images/connect-consent/computer.svg", width: "55", height: "48", alt: "", className: "mr-[5px]" }))),
                    React.createElement("div", null,
                        React.createElement(Image, { src: "/assets/images/connect-consent/header-base-img.svg", alt: "", width: "195", height: "78" }))),
                React.createElement("div", { className: "mx-auto mb-4 flex flex-col items-center justify-between text-[#14141C] sm:mb-6 md:mb-10 desktop:mb-6" },
                    React.createElement(RouteTitle, { className: "text-center leading-none" }, getDefaultHeaderText())),
                React.createElement("div", { className: "flex flex-1 flex-col items-center justify-between text-white" },
                    React.createElement("div", { className: "w-full space-y-3 pb-4 md:space-y-6 desktop:space-y-4" }, items.map(function (_a, idx) {
                        var icon = _a.icon, title = _a.title, text = _a.text;
                        return (React.createElement("div", { className: "flex items-center text-black-100", key: "".concat(icon, "-").concat(idx) },
                            React.createElement("div", { className: "mr-4 flex h-5 w-5 items-center md:mr-5 md:h-6 md:w-6" }, typeof icon === "string" ? (React.createElement(Image, { src: icon, alt: "" })) : (icon)),
                            React.createElement("div", { className: "flex-1" },
                                React.createElement("h3", { className: "font-bold leading-none text-black-100" }, title),
                                React.createElement("div", { className: "flex min-w-[55px] flex-col" },
                                    React.createElement("p", { className: "mt-[3px] w-full text-[15px] font-light leading-none text-[#14141c]" }, text)))));
                    })))),
            React.createElement("div", { className: "mt-auto p-6" },
                React.createElement(ConnectButton, { id: "trellis-consent", onClick: handleSubmit }, "Continue"),
                React.createElement("p", { className: "mx-[5px] mt-4 text-center text-sm leading-none text-gray-100" },
                    "By selecting \"Continue\" you agree to the",
                    " ",
                    React.createElement("a", { className: "border-b border-solid border-gray-200 text-gray-100 no-underline", href: trellisPrivacyPolicyURL, target: "_blank", rel: "noreferrer" }, "Trellis End User Privacy Policy"))))));
}
